import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

import showAlert from '../../common/util/showAlert';

export default class InviteCodeDeleteConfirmationModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.inviteCodeData = this.attrs.inviteCodeData;
    this.loading = false;
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.lib.confirmation');
  }

  content() {
    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div style="font-size: 16px;padding-bottom: 20px;">
            {app.translator.trans('ziven-u2di.forum.invite-code-delete-confirmation')}
          </div>
          <div>
            {Button.component({
                className: 'Button Button--primary',
                disabled: this.loading,
                onclick: (e) => {
                  this.deleteInviteCode(e);
                }
              },
              app.translator.trans('ziven-u2di.lib.confirm')
            )}&nbsp;
            {Button.component({
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  deleteInviteCode(e){
    e.preventDefault();

    this.loading = true;
    $(".Modal-close").hide();

    this.inviteCodeData.save({isDelete:1})
    .then(() => {
        this.loading = false;
        this.hide();

        showAlert(app.translator.trans("ziven-u2di.forum.invite-code-delete-sucess"),"success");
        $("#u2diInviteCode"+this.inviteCodeData.id()).css("pointer-events","none")
        $("#u2diInviteCode"+this.inviteCodeData.id()).delay(500).fadeOut(500);
        m.redraw();
      },
      (response) => {
        this.loading = false;
      }
    );
  }
}
